var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
// we replaced `isomorphic-unfetch` because we want it to support web-workers
// see: https://github.com/developit/unfetch/pull/109
var unfetch = require('./isomorphic-unfetch');
// https://github.com/developit/unfetch/issues/46
var fetch = unfetch;
export function joinUrls(baseUrl, relativeUrl) {
    return baseUrl.replace(/\/+$/, '') + '/' + relativeUrl.replace(/^\/+/, '');
}
export function showToast(error, method, args, baseUrl) {
    if (process.env.NODE_ENV !== 'production') {
        if (process.env.browser) {
            var Toastify = require('toastify-js');
            createCss();
            Toastify({
                duration: 60000,
                gravity: 'bottom',
                position: 'right',
                stopOnFocus: true,
                close: true,
                text: "\uD83D\uDE31\uD83D\uDE31\uD83D\uDE31 There was an error on your server function call. Click to open on your IDE<BR/>\n                  File: <b style=\"color: blue;cursor: pointer;\"><u>" + method.fileName + "</u></b>, method: <b>" + method.functionName + "</b>: <BR/>\n                  Arguments: <b>" + args + "</b> <BR/>\n                  Error: " + error.errors[0].message + "\n              ",
                className: 'popover',
                onClick: function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var _a, file, line, col;
                        return __generator(this, function (_b) {
                            switch (_b.label) {
                                case 0:
                                    _a = error.errors[0].stack.match(/\/([/\w-_.]+\.[j|t]sx?):(\d*):(\d*)/), file = _a[1], line = _a[2], col = _a[3];
                                    return [4 /*yield*/, fetch(baseUrl + ("/_launchEditor_?file=" + file + "&line=" + line + "&col=" + col), {
                                            credentials: 'same-origin',
                                            method: 'GET',
                                        })];
                                case 1:
                                    _b.sent();
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
            }).showToast();
        }
    }
}
function createCss() {
    var toastStyle = 'toast-style';
    if (document.querySelector("#" + toastStyle)) {
        return;
    }
    var css = document.createElement('style');
    css.id = toastStyle;
    css.textContent = "\n    .toast-close {\n      position: absolute;\n      top: 0px;\n      right: 0px;\n      margin: 5px;\n      cursor: pointer;\n    }\n    .popover {\n      position: absolute;\n      right: 20px;\n      padding: 10px 20px;\n      max-width: 500px;\n      background: #fff;\n      color: #000;\n      font: initial;\n      cursor: initial;\n      letter-spacing: initial;\n      text-shadow: initial;\n      text-transform: initial;\n      visibility: initial;\n      font-size: 12px;\n      line-height: 1.5;\n      align-items: center;\n      box-shadow: 0 11px 40px 0 rgba(0, 0, 0, 0.25), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n      transition: bottom 1.5s ease;\n    }\n  ";
    document.body.appendChild(css);
}
//# sourceMappingURL=utils.js.map